import { MemberRole } from '../../../models/CurrentUserProject';
import type { AccessTo } from './types';

const CLIENT_ROLES = new Set<MemberRole>([
  MemberRole.GUEST,
  MemberRole.COLLABORATOR,
  MemberRole.ANONYMOUS
]);

/**
 * Client users should not be able to set task metadata via slash commands
 * in the create-task rich text editor.
 */
export const isClientUserForTaskShortcuts = (
  role: MemberRole | undefined,
  isLoginlessFeedback: boolean
): boolean => {
  if (isLoginlessFeedback) return true;
  if (!role) return false;

  return CLIENT_ROLES.has(role);
};

export type RichTextTaskFieldShortcutPermissions = Pick<
  AccessTo,
  | 'canEditAssignees'
  | 'canEditSeverity'
  | 'canEditStatus'
  | 'canEditTags'
  | 'canEditDueDate'
>;

export const resolveRichTextTaskFieldShortcutPermissions = (
  accessTo: RichTextTaskFieldShortcutPermissions,
  isClientUser: boolean
): RichTextTaskFieldShortcutPermissions => ({
  canEditAssignees: accessTo.canEditAssignees && !isClientUser,
  canEditSeverity: accessTo.canEditSeverity && !isClientUser,
  canEditStatus: accessTo.canEditStatus && !isClientUser,
  canEditTags: accessTo.canEditTags && !isClientUser,
  canEditDueDate: !!accessTo.canEditDueDate && !isClientUser
});
